import { useContext } from 'react';
import { useQuery } from 'react-query';
import { getBulkImportJobError } from 'services';
import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { getTitleFromHeader } from '../utils';

export const FILE_WITH_ERROR_QUERY_KEY = 'fileWithError';

export const useGetDataFileWithErrors = (jobId: string) => {
  const { corpAcctNbr } = useContext(FeatureContext);

  const handleDownload = ({ data: file, headers }) => {
    const name = getTitleFromHeader(headers['content-disposition']);
    const csvDownloadLink = document.createElement('a');
    csvDownloadLink.href = URL.createObjectURL(file);
    csvDownloadLink.download = name;
    csvDownloadLink.click();
  };

  return useQuery(
    [FILE_WITH_ERROR_QUERY_KEY, jobId],
    () =>
      getBulkImportJobError(corpAcctNbr, jobId).then((response) => {
        handleDownload(response);
      }),
    {
      enabled: false,
    },
  );
};
